import { PaginationQuery } from "@/interfaces/PaginationQuery";
import { MediaContent } from "@/interfaces/MediaContent";
import ApiService from "./api.service";

interface CreateT {
  title: string;
  detail?: string;
  riskLevels: string[];
  categoryId?: string;
  youtubeUrl?: string;
}

interface UpdateT extends Partial<CreateT> {}

interface FindT extends PaginationQuery {}

export class MediaContentService extends ApiService<
  MediaContent,
  CreateT,
  UpdateT,
  FindT
> {
  constructor() {
    super("media-contents");
  }
}
